export enum DepositFilterState {
  ALL = 'ALL',
  BORROWED = 'BORROWED',
  RETURNED = 'RETURNED',
  ON_HOLD = 'ON_HOLD',
  NO_DELETE = 'NO_DELETE',
}
